import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { getBestCategoryCarsPath, CarReviewsModel } from 'client/data/models/car-reviews';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { BestCategoryCard } from './best-category-card';

const DEFAULT_TITLE = 'Our experts rank the best cars in every category';

function BestCategoryCarsUI({ title = null, promoText = '', categoryCars = null, isMobile = false }) {
  if (!categoryCars) {
    return null;
  }

  const categoryCarsComponents = categoryCars
    .map(
      category =>
        !!get(category, 'segmentRatings[0]') && (
          <Col key={category.id} xs={6} md={4} lg={3}>
            <BestCategoryCard category={category} isLazyImage />
          </Col>
        )
    )
    .filter(value => value);

  if (isMobile) {
    categoryCarsComponents.splice(
      2,
      0,
      <Col xs={12} className="mnavblock text-center mb-1" key="mnavblock">
        <AdUnit
          adName="mnavblock"
          xs
          sm
          position={'1'}
          renderWhenViewable={false}
          showLabel={false}
          refreshable={false}
        />
      </Col>
    );
  }

  return (
    <div className="best-category-cars mt-2">
      <div className="d-flex justify-content-between align-items-end">
        <h2 className="heading-3">{title || DEFAULT_TITLE}</h2>
        <AdUnit
          adName="navblock"
          md
          lg
          xl
          position={'1'}
          renderWhenViewable={false}
          showLabel={false}
          refreshable={false}
        />
      </div>

      {!!promoText && (
        <ContentFragment componentToUse="p" classes="text-gray-darker mb-0_5 size-16">
          {promoText}
        </ContentFragment>
      )}
      <Row>{categoryCarsComponents}</Row>
    </div>
  );
}

BestCategoryCarsUI.propTypes = {
  title: PropTypes.string,
  promoText: PropTypes.string,
  categoryCars: PropTypes.arrayOf(TypeRankingsEntities.VehicleRanking),
  isMobile: PropTypes.bool,
};

const stateToPropsConfig = {
  categoryCars: bindToPath(getBestCategoryCarsPath, CarReviewsModel),
};

export const BestCategoryCars = connectToModel(BestCategoryCarsUI, stateToPropsConfig);
